var _rect, _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentlenzApplicantEvidenceJourneyDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TalentLenz applicant evidence document icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 8,
    width: 36,
    height: 48,
    rx: 7,
    fill: "#F3F8FF",
    stroke: "#087CFF",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 24h20M22 32h20M22 40h13",
    stroke: "#087CFF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 48,
    r: 10,
    fill: "#FF3885"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m42 48 3 3 6-7",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentlenzApplicantEvidenceJourneyDocumentIcon);
export default __webpack_public_path__ + "static/media/talentlenz-applicant-evidence-journey-document-icon.32988466a71304d834cff2f84f00ba59.svg";
export { ForwardRef as ReactComponent };